document.addEventListener("DOMContentLoaded", function () {
  const priceTextElement = document.querySelector('.price-item--regular');
  if (!priceTextElement) return;

  // 金額を取得・整形（¥マークとカンマ除去）
  const priceText = priceTextElement.textContent.trim();
  const price = parseInt(priceText.replace('¥', '').replace(/,/g, ''));

  // デフォルト倍率（非会員など）
  let multiplier = 0.01;

  // ランクを取得
  const rankElement = document.getElementById('hidden-rank');
  if (rankElement) {
    const rankText = rankElement.textContent.trim();
    const rank = rankText.split(' ')[0]; // 例: "SILVER 会員"

    switch (rank) {
      case 'GREEN':
        multiplier = 0.01;
        break;
      case 'BRONZE':
        multiplier = 0.02;
        break;
      case 'SILVER':
        multiplier = 0.05;
        break;
      case 'GOLD':
        multiplier = 0.07;
        break;
      case 'BLACK':
        multiplier = 0.1;
        break;
      default:
        multiplier = 0.01;
    }
  }

  // ポイント計算（小数切り捨て）
  const discountedPrice = Math.floor(price * multiplier);

  // 表示部分の描画処理
  const rankPointElement = document.getElementById('rank-point');
  if (rankPointElement) {
    rankPointElement.innerHTML = `
      <p style="font-size: 1rem; margin: 0;">
        ${discountedPrice} ポイント付与
      </p>
    `;
  } else {
    const rankPointNoMember = document.getElementById('rank-point-noMember');
    if (rankPointNoMember) {
      rankPointNoMember.innerHTML = `
        <p style="font-size: 1rem; margin: 0;">
          会員登録すると ${discountedPrice} ポイント付与
        </p>
      `;
    }
  }
});